import React from 'react';
import { Route as RouteDom } from 'react-router-dom';

import privateRoutes from './private';
import publicRoutes from './public';
import { checkValidRole } from 'utilities/common';
import { PrivateRoute } from 'components/Atoms';

const renderRoutes = (isPrivate = false, userRole = '') => {
  let routes = publicRoutes;
  let Route = RouteDom;

  if (isPrivate) {
    routes = privateRoutes;
    Route = PrivateRoute;
  }

  return routes.map(
    ({ component: Component, roles, ...rest }, idx) =>
      checkValidRole(roles, userRole) && (
        <Route {...rest} key={idx} render={(props) => <Component {...props} />}>
          <Component />
        </Route>
      )
  );
};

export default renderRoutes;
